import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnersHub from "@/pages/partners/PartnersHub";

export const Route = createFileRoute("/partners/")({
  head: () => seoHead("/partners"),
  component: PartnersHub,
});
